import { useEffect, useMemo, useState } from "react";
import { usePreferences } from "context/PreferencesContext";
import { mergeAppearance, resolvePaletteMode } from "utils/appearanceDefaults";

const useSystemPrefersDark = () => {
  const [prefersDark, setPrefersDark] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(prefers-color-scheme: dark)").matches
  );

  useEffect(() => {
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = (event) => setPrefersDark(event.matches);
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, []);

  return prefersDark;
};

/** Resolved light/dark palette mode from appearance preferences + system setting. */
export const usePaletteMode = () => {
  const { appearance } = usePreferences();
  const systemPrefersDark = useSystemPrefersDark();
  const mergedAppearance = useMemo(() => mergeAppearance(appearance), [appearance]);

  return useMemo(
    () => resolvePaletteMode(mergedAppearance.theme, systemPrefersDark),
    [mergedAppearance.theme, systemPrefersDark]
  );
};
